export default "Escape Zone opened in late 2018. \n\n<!-- https://www.jv.dk/esbjerg/Splat-og-mindfuck-Ny-voksenleg-skal-chokere-gaesterne/artikel/2649734 -->";